import {get, post, put, del} from "@/utils/request";

export default {
    getList: (param) => {
        return get('/comments', param);
    },
    getData: (postId) => {
        return get('/comments/'+postId);
    },
    addData: (data) => {
        return post('/comments/add', data);
    },
    updateData: (data) => {
        return put('/comments', data);
    },
    deleteData: (id) =>{
        return del('/comments/'+id);
    }
}